module.exports = __webpack_public_path__ + "imgs/staff2.bd75b44c.webp";